import { GrowthBookType } from "@/src/type/growthbook";
import { ObjectHelper } from "../util";

function checkAndMergeVariant(original: any, componentId?: string, variants?: Record<string, GrowthBookType.ContentVariants>) {
  if (!variants || !componentId) {
    return original;
  }

  const variant = variants[componentId];
  if (!variant) {
    return original;
  }
  return ObjectHelper.deepMerge(original, variant.variant);
}

function getVariant(componentId?: string, variants?: Record<string, GrowthBookType.ContentVariants>) {
  if (!variants || !componentId) {
    return null;
  }

  return variants[componentId];
}

function getExperiments(growthBook: GrowthBookType.GrowthBookAndContentVariants) {
  const experiments: Record<string, GrowthBookType.FeatureRule> = {};

  if (!growthBook.features) {
    return experiments;
  }

  for (const featureDefinition of Object.values(growthBook.features)) {
    if (featureDefinition.rules && featureDefinition.rules.length > 0) {
      for (const rule of featureDefinition.rules) {
        experiments[rule.key] = rule;
      }
    }
  }
  return experiments;
}

export default {
  checkAndMergeVariant,
  getVariant,
  getExperiments,
};
